export default __webpack_public_path__ + "static/media/unequip.d7e20258.svg";